// A single KPI stat tile for the Home dashboard (Fig29). Every value rendered
// here MUST come from real query data — no placeholders, no fabricated deltas.
// When a caller has no honest caption to show, it should pass `undefined`
// rather than inventing one.
import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

interface StatTileProps {
  icon: LucideIcon
  label: string
  value: number | string
  caption?: ReactNode
}

export default function StatTile({ icon: Icon, label, value, caption }: StatTileProps) {
  return (
    <div className="light-card p-4" data-testid={`stat-tile-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
        <Icon size={14} className="text-iflow-500" aria-hidden />
        {label}
      </div>
      <p className="text-2xl font-bold text-gray-900">{value}</p>
      {caption && <p className="mt-1 text-xs text-gray-500">{caption}</p>}
    </div>
  )
}
